module.exports = __webpack_public_path__ + "img/sloth_logo.9868286c.png";